import { Spin } from "antd";
import React, { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@tanstack/react-query";
import { queryApi } from "../store/actions/common";
import { queryClient } from "../store/queryClient";
import { triggerNotification } from "../store/directActions";

const PaymentFallback: React.FC = ({ profileData }: { profileData: any }) => {
  const navigate = useNavigate();

  // Mutation for payment callback
  const { mutate: paymentCallback, isPending: isCallbackLoading } = useMutation(
    {
      mutationFn: (userId: string | number) => {
        // Assuming the payment callback endpoint - adjust if different
        return queryApi(`store/callback`, "GET");
      },
      onSuccess: () => {
        navigate("/");
      },
    }
  );

  const handlePaymentCallback = useCallback(() => {
    // @ts-ignore - queryApi returns data directly despite ApiResponse type signature
    const userId = profileData?.data?.id;
    if (userId) {
      paymentCallback(userId);
    }
  }, [profileData, paymentCallback]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handlePaymentCallback();
    }, 5000); // 3 seconds delay before retrying

    return () => clearTimeout(timer);
  }, [handlePaymentCallback]);

  return (
    <div
      className="w-full min-h-screen flex items-center flex-col justify-center app-bg app-text"
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Spin size="large" />
      <p className="mt-4 text-lg font-medium">Loading Payment Status</p>
    </div>
  );
};

export default PaymentFallback;
